export default {"src":"/_next/static/media/shopping.b5615fe8.svg","height":57,"width":46,"blurWidth":0,"blurHeight":0};